import { BaseCustomError, ErrorCode } from './base';

export class NotImplementedError extends BaseCustomError {
  constructor(messageSuffix: string, errorCode: ErrorCode = ErrorCode.UnknownError) {
    super(501, `Not Implemented: ${messageSuffix}`, undefined, errorCode);
  }
}
